import * as a from "fp-ts/lib/Option";
function t(o) {
  const n = o.cata(() => a.none, a.of);
  return Object.assign(o, n);
}
export {
  t as o
};
//# sourceMappingURL=overloadMaybe-Bl7wbAkx.mjs.map
